import React, { useEffect, useState } from "react";
import { Outlet, redirect, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";

// css
import styles from "./mainLayout.module.scss";

import Sidebar from "../../components/Header/sidebar/Sidebar";
import InactiveSessionLogoutPopup from "components/Modals/InactiveSessionLogoutPopup/Index";
import { useSelector } from "react-redux";
import TermsAndConditionsPop from "components/Modals/TermsAndConditionsPop";

const MainLayout = () => {
  const userInfo = useSelector((state) => state.auth.userInfo)
  const [sidebar, setSidebar] = useState();
  const location = useLocation();
  const navigate = useNavigate()

  console.log('userInfo', userInfo)
  const [termsPop, setTermsPop] = useState(false)

  useEffect(() => {
    if (userInfo?.termsAndConditionsStatus == 'pending') {
      // navigate('/onboard')
      setTermsPop(true)
    }

  }, [userInfo])
  return (
    <>
      <TermsAndConditionsPop show={termsPop} setShow={setTermsPop} />
      <InactiveSessionLogoutPopup />
      <div className={`${styles.mainLayout} d-flex align-items-start`}>
        <Sidebar sidebar={sidebar} setSidebar={setSidebar} />
        <main
          className={`${styles.MainBody} ms-auto MainBody position-relative`}
        >
          <Header sidebar={sidebar} setSidebar={setSidebar} />
          <Outlet />
        </main>
      </div>
    </>
  );
};
export default MainLayout;
